import type { FaireProductEntity } from "../../entity_types/product";

export const p_khzqnw73ua: FaireProductEntity = {
  token: "p_khzqnw73ua",
  type: "product",
  name: "Ethnic Style Jacquard Women's Socks",
  brandToken: "b_4z8um3dept",
  brandName: "Sheer Trend",
  imageUrl:
    "https://cdn.faire.com/fastly/4852448a0d42bfdd33b3a351dd5ef124fdb6dadd7c25efcf08ad664fd4c8b132.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c23e71ab38e237f4111708e7d6a2c107889dfafe54db692ac1cbcef147877399.jpeg",
    "https://cdn.faire.com/fastly/4ccc82650bc839af0c4d011cc3b09f644c994266b11d140c4e1f1411dbb2ac26.jpeg",
    "https://cdn.faire.com/fastly/880e16bb47facab983b341252bf6954520d512cd03ca4d1f3a650ca5bd7e8072.jpeg",
    "https://cdn.faire.com/fastly/df870ba22cac46342d891ec224bcdd8e95a0545caccd437b9a337a7c74d1c318.jpeg",
    "https://cdn.faire.com/fastly/261057ec3a57c4b29d7ca24fe007cabfcf44517763d127ca2c6ebd8a1bcc28a3.jpeg",
    "https://cdn.faire.com/fastly/5dc5b3ad9ffa0618595c82cb9da4a95fe216ebf2fc3c3a0d8f5e2b24215a2a79.jpeg",
  ],
  priceDollars: 1.99,
  description:
    "• Quantity: 1 Pcs\n• Season: Autumn, Winter\n• Size: One Size\n• Style: Casual, Vintage\n• Material: Cotton",
  tags: [],
  msrpDollars: 3.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:40.145Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
